import { render, staticRenderFns } from "./PostaGuverciniChannels.vue?vue&type=template&id=72d304cc&scoped=true"
import script from "./PostaGuverciniChannels.vue?vue&type=script&lang=js"
export * from "./PostaGuverciniChannels.vue?vue&type=script&lang=js"
import style0 from "./PostaGuverciniChannels.vue?vue&type=style&index=0&id=72d304cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d304cc",
  null
  
)

export default component.exports